import DlBreadcrumb from "./main.vue"

/* istanbul ignore next */
DlBreadcrumb.install = function(Vue) {
  Vue.component(DlBreadcrumb.name, DlBreadcrumb)
}

export default DlBreadcrumb
